<template>
    <div id="app" :style="style">
        <router-view />
    </div>
</template>


<script>
import Util from '@/utils/index';
export default {
	data() {
		return {
			style: {},
		};
	},
	mounted() {
		// 非移动端时 监控浏览器窗口高度
		if (!Util.isMobile() && this.isNoPay) {
			window.addEventListener('resize', this.updateWindowHeight);
			this.updateWindowHeight();
		}
	},
	beforeDestroy() {
		if (!Util.isMobile() && this.isNoPay) {
			// 移除窗口大小监听器
			window.removeEventListener('resize', this.updateZoomFactor);
		}
	},
	computed: {
		isNoPay() {
			return this.$route.query.from !== 'pay';
		},
	},

	methods: {
		updateWindowHeight() {
			let windowHeight = window.innerHeight;
			let num = windowHeight / 784;
			this.style = { zoom: num > 1 ? num : 1 };
		},
	},
};
</script>



<style lang="scss">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
</style>
